module.exports = __webpack_public_path__ + "assets/images/spor_fm_tv5_logo_v2_1.ec5733ee30fe609d10e1d734a32d4abb.png";